import React from 'react';
import classnames from 'classnames';
import PageContainer from '../PageContainer';
import DefaultPageContent from '../DefaultPageContent';
import s from './BasePageLayout.scss';

export interface Props {
  feedType?: string;
  title?: React.ReactNode;
  tagLine?: React.ReactNode;
  headerNavigation?: React.ReactNode;
  headerRightSideContent?: React.ReactNode;
  headerLeftSideContent?: React.ReactNode;
  headerIsStickyOnScrollUp?: boolean;
  customHeader?: React.ReactNode;
  withNavigation?: boolean;
  withNetworkBar?: boolean;
  contentClassName?: string;
  titleClassName?: string;
  children?: React.ReactNode;
}

const BasePageLayout: React.FC<Props> = ({
  title,
  tagLine,
  headerNavigation,
  headerRightSideContent,
  headerLeftSideContent,
  headerIsStickyOnScrollUp,
  feedType,
  children,
  withNavigation,
  withNetworkBar,
  contentClassName,
  titleClassName,
  customHeader,
}) => {
  return (
    <PageContainer
      title={title}
      tagLine={tagLine}
      headerNavigation={headerNavigation}
      headerLeftSideContent={headerLeftSideContent}
      headerRightSideContent={headerRightSideContent}
      headerIsStickyOnScrollUp={headerIsStickyOnScrollUp}
      withNavigation={withNavigation}
      withNetworkBar={withNetworkBar}
      titleClassName={titleClassName}
      customHeader={customHeader}
    >
      <div
        className={classnames(
          s['root'],
          s[`feed-${feedType}`],
          contentClassName
        )}
      >
        {children ? children : <DefaultPageContent />}
      </div>
    </PageContainer>
  );
};
BasePageLayout.displayName = 'BasePageLayout';

export default BasePageLayout;
